import AboutUs from "./AboutUsView";

export const AboutUsContainer = () => {
  return <AboutUs />;
};
